import { render, staticRenderFns } from "./SaleReportProductAndCustomers.vue?vue&type=template&id=104d55c9&"
import script from "./SaleReportProductAndCustomers.vue?vue&type=script&lang=js&"
export * from "./SaleReportProductAndCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports